// extracted by mini-css-extract-plugin
export default {"secondary-nav-loading-wrapper":"HeaderWrapper___style-module__secondary-nav-loading-wrapper___6Qbc4"};